import React from 'react';
import PropTypes from 'prop-types';
import {getWord} from "../../utils/tenant";
import css from './StaffContactNumbers.css';

export default class StaffContactNumbers extends React.Component {

    getPhoneNumber(phone, phoneLabel) {
        if(!phone) return;
        return <div>{getWord(phoneLabel)}<a href={`tel:${phone}`} title={getWord(phoneLabel)}>{phone}</a></div>;
    }

    render() {
        const { mobilePhone, videoPhone } = this.props;
        return (
            <div className={css['container']}>
                {this.getPhoneNumber(mobilePhone, 'mobilePhone')}
                {this.getPhoneNumber(videoPhone, 'videoPhone')}
            </div>
        );
    }
}

StaffContactNumbers.propTypes = {
    mobilePhone: PropTypes.string,
    videoPhone: PropTypes.string
};
